export class OrderItemRequest {

    public orderItemId: number;
    public skuId: string;
    public skuOptionIds: number[];
    public setNewQuantity: boolean;

    constructor(public productId: Number,
                public model: String | null,
                public quantity: Number,
                public itemAttributes: any) {}
}
